import { Link } from "@tanstack/react-router";
import { Spinner } from "@/components/ui/spinner";
import logoPng from "@/logo.png";

/**
 * Loading screen shown while restoring authentication from localStorage.
 * Only appears when user has saved auth tokens (returning visitor).
 */
export function AuthLoading() {
	return (
		<div className="flex min-h-screen items-center justify-center bg-muted">
			<div className="flex flex-col items-center gap-4">
				{/* Logo */}
				<Link to="/">
					<img src={logoPng} alt="m8tes.ai" className="h-16 dark:invert" />
				</Link>

				{/* Spinner */}
				<Spinner className="size-6" />
			</div>
		</div>
	);
}
